import axios from '@/api/axios';

export const parameterStoreService = {
  getParameters: async (): Promise<Record<string, string>> => {
    const url = `/v2/admin/others/parameters`;
    const response = await axios.get<Record<string, string>>(url);
    return response.data;
  },
};
